import FloatingVue from 'floating-vue'
import 'v3-infinite-loading/lib/style.css'
import mixpanel from 'mixpanel-browser'
import MasonryWall from '@yeger/vue-masonry-wall'
import InstantSearch, { AisConfigure, AisInfiniteHits } from 'vue-instantsearch/vue3/es'

import 'floating-vue/dist/style.css'

import 'vue-multiselect/dist/vue-multiselect.min.css'
import '~~/assets/css/index.css'
import '~~/assets/css/full-calendar.css'
import '~~/assets/css/nprogress.css'
import '~~/assets/css/vue-multiselect.css'

export default defineNuxtPlugin((nuxtApp) => {
  const app = nuxtApp.vueApp

  app.use(FloatingVue)
  app.use(MasonryWall)
  app.use(InstantSearch)

  app.component('ais-infinite-hits', AisInfiniteHits)
  app.component('ais-configure', AisConfigure)

  if (import.meta.env.PROD)
    mixpanel.init('3d0424bcff42edc3fac356b3e0676cff')
})
